/*
 * Copyright (c) 2022-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import DisplayIcon from "./Icons/DisplayIcon.jsx";
import Webcam from "react-webcam";


class MobilePhotoCaptureComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFacingMode: false,
            isFlashlightOn: false,
            didScan: false

        }

        this.camera = React.createRef()
    }


    componentDidMount() {
        navigator.permissions.query({name: 'camera'})
            .then((permissionObj) => {
            })
            .catch((error) => {
                console.log('Got error :', error);
            })

    }


    render() {
        let width = "700px"
        let height = "700px"
        return (
            <div className={"relative"}>
                <div style={{width: width, height: height}}
                     className={"absolute top-0 left-0  flex justify-center  items-center"}>

                </div>

                <div className={"bg-gray-300 flex justify-center align-middle"} style={{width: width, height: height}}>

                    <Webcam
                        ref={this.camera}
                        audio={false}
                        height={1080}
                        screenshotFormat="image/jpeg"
                        width={1920}
                        torch={this.state.isFlashlightOn}
                        videoConstraints={{
                            width: 1920,
                            height: 1080,
                            facingMode: (this.state.isFacingMode ? ("user") : ("environment"))
                        }}
                    >

                    </Webcam>

                </div>

                <div style={{width: width}}
                     className={"absolute bottom-0 left-0 h-12 flex justify-center space-x-2.5 align-middle bg-gradient-to-t from-gray-900 to-transparent"}>
                    <button type="button" onClick={() => {
                        this.setState((state) => ({isFacingMode: !state.isFacingMode}))
                    }}
                            className="inline-flex items-center p-2 border border-gray-300 rounded-full shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 cursor-pointer h-10 w-10">
                        <DisplayIcon className={"h-6 w-6"} iconName={"MdOutlineCameraswitch"}/>
                    </button>
                    <button type="button" onClick={() => {
                        const imageSrc = this.camera.current.getScreenshot();
                        if (this.props.onImageCapture !== undefined) {
                            this.props.onImageCapture(imageSrc)
                        }
                    }}
                            className="inline-flex items-center p-3 border border-gray-300 rounded-full shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 cursor-pointer h-14 w-14">
                        <DisplayIcon className={"h-8 w-8"} iconName={"MdCamera"}/>
                    </button>
                    <button type="button" onClick={() => {
                        this.setState((state) => ({isFlashlightOn: !state.isFlashlightOn}))
                    }}
                            className="inline-flex items-center p-2 border border-gray-300 rounded-full shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 cursor-pointer h-10 w-10 ">
                        <DisplayIcon className={"h-6 w-6"} iconName={"IoFlashlightOutline"}/>
                    </button>

                </div>


            </div>
        );
    }
}

MobilePhotoCaptureComponent.propTypes = {};

export default MobilePhotoCaptureComponent;